import React, {Component, useEffect} from 'react';
import {Dropdown, Divider} from 'semantic-ui-react';
import axios from 'axios'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { faPen } from '@fortawesome/free-solid-svg-icons'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'

// const SeeResultsTab = () => <div> see results goes here. </div>

class PollCard extends Component {
    constructor(props) {
        super(props)

        this.state = {
            dropDownClicked: false,


        }
    }

    changeDropDown = () =>{
        this.setState({dropDownClicked: !this.state.dropDownClicked})
    }
    async deletePoll(){
        console.log("inside delete poll = ", this.props.item._id)
        const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';
        await axios.post(baseURL+'/poll/delete', {id: this.props.item._id}).then(response=>console.log(response)).catch(error=>console.log("error deleting polls"))
        alert("You have deleted the Poll.")
        await axios.post("http://localhost:8080/slack/message", {email: "abelp915@gmail.com", message: "A poll has been deleted"})
    }
    render() {
        
        console.log("inside graph props = ",this.props.item)
        // return <div>test</div>
        const choice = []
        if(this.props.item == undefined) return null;
        for(const i of this.props.item.choices){
            choice.push(<div className="choiceBar">{i.description}</div>) 
        }
        if(this.state.dropDownClicked && this.props.item.question!=undefined){ 
            return (

                <div className="pollContainer">
                    <div className="dropDown" onClick={()=>{this.changeDropDown()}}><FontAwesomeIcon icon={faChevronDown} style={{color: "grey"}} /></div>
                    <div className="question"> {this.props.item.question}</div>
                    <div className="pollChoices">
                        {choice}

                    </div>
                    {/* <div className="pollLikes"> {this.props.item.totalLikes} likes</div> */}
                    <div style={{marginLeft: "80%"}}><FontAwesomeIcon onClick={() => {
                        console.log('edit pressed\n\n\n')
                        this.props.formEdit(this.props.item)
                        }} icon={faPen} style={{color: "grey"}} />{'\u00A0'}{'\u00A0'}{'\u00A0'}<FontAwesomeIcon icon={faTrashAlt} style={{color: "grey"}} onClick={()=>this.deletePoll()}/></div>
        
        
                </div>
            )
        }
        else{
            if(this.props.item.question!=undefined){
            return (

                <div className="pollContainer" style={{height: "100px"}}>
                    <div className="dropDown" onClick={()=>{this.changeDropDown()}}><FontAwesomeIcon icon={faChevronDown} style={{color: "grey"}} /></div>
                    <div className="question" styel={{marginTop: "-10%"}}> {this.props.item.question}</div>
                    {/* <div className="pollLikes"> {this.props.item.totalLikes} likes</div> */}
                    <div style={{marginLeft: "80%"}}><FontAwesomeIcon onClick={() => {
                        console.log('edit pressed\n\n\n')
                        // this.deletePoll()
                        // await axios.post("http://localhost:8080/poll/delete", {id: this.props.item._id}).then(response=>console.log(response)).catch(error=>console.log("error deleting polls"))
                        this.props.formEdit(this.props.item)
                        }}  icon={faPen} style={{color: "grey"}} />{'\u00A0'}{'\u00A0'}{'\u00A0'}<FontAwesomeIcon icon={faTrashAlt} style={{color: "grey"}} onClick={()=>this.deletePoll()}/></div>
        
                </div>
            )

        }}
    }
}
export default PollCard;